export const unMaksPhoneNumber = (string) => string.replace('+7', '').replace(/\D/ig, '');
